import { render, staticRenderFns } from "./organizationSelect.vue?vue&type=template&id=960dab74&"
import script from "./organizationSelect.vue?vue&type=script&lang=js&"
export * from "./organizationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports